import { render } from "./DealIntro.vue?vue&type=template&id=fe244196&scoped=true"
import script from "./DealIntro.vue?vue&type=script&lang=js"
export * from "./DealIntro.vue?vue&type=script&lang=js"

import "./DealIntro.vue?vue&type=style&index=0&id=fe244196&lang=scss"
import "./DealIntro.vue?vue&type=style&index=1&id=fe244196&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe244196"]])

export default __exports__